<script>
import axios from '@/utils/axios';

export default {
 inject: ['setLoading'],
 data() {
  return {
    title: "Inventory",
    text: "Inventory",
    activity_logs: [],
    activity_challan_number: '',
    search: '',
    data: [],
    stats: [],
    pending_count: 0,
    activeStatus: '',
    pagination: {
     current_page: 1,
     per_page: 25,
     last_page: 1,
     total: 0,
     links: [],
    },
   };
  },

  computed: {
   text1(){
    return `Delivery Challans (${this.pagination.total})`;
   }, 
   serialNo(){
    return (this.pagination.current_page - 1) * this.pagination.per_page;
   } 
  },

    mounted(){
      this.loadChallans();
      this.loadStats();
    },

  methods: {

    async openProduction(row) {
      await this.$refs.productionModal.open(row.id);
      this.$nextTick(() => {
        this.$openModal('production_modal');
      });
    },

        openReturnDC(row) {
      this.$router.push({
        path: '/inventory/delivery-challan-returns',  
        query: { create_from_dc: row.id }
      });
    },

    onUpdated() {
  this.loadChallans();
  this.loadStats();
},

    filterByStatus(status) {
  if (this.activeStatus === status) {
    this.activeStatus = '';
  } else {
    this.activeStatus = status;
  }
  this.loadChallans();
},

async loadStats() {
  try {
    const response = await axios.get('/inventory/delivery-challans/stats');
    this.stats = response.data.data;
    if (this.auth.type === 'ADMIN') {
      const pendingRes = await axios.get('/inventory/delivery-challans/pending-items?page=1');
      const challans = pendingRes.data.data.data || [];
      this.pending_count = challans.filter(c => c.challan_items && c.challan_items.length > 0).length;
    }
  } catch (error) {
    console.log('Stats load error:', error.message);
  }
},

openPendingItems() {
  this.$refs.pendingItemsModal.loadPendingItems();
  this.$openModal('pending_items_modal');
},

    formatDateTime(dateStr) {
  if (!dateStr) return '-';
  const d = new Date(dateStr);
  return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) 
    + ', ' + d.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true });
},

    openActivityLog(row) {
  this.activity_logs = row.activities || [];
  this.activity_challan_number = row.challan_number;
  this.$openModal('challan_activity_modal');
},
recipientType(row) {
  const map = {
    'App\\Models\\Engineer': { label: 'Engineer', class: 'bg-purple-subtle text-purple' },
    'App\\Models\\Customer': { label: 'Customer', class: 'bg-info-subtle text-info' },
    'App\\Models\\WorkOrder': { label: 'Work Order', class: 'bg-success-subtle text-success' },
    'App\\Models\\SalesExecutive': { label: 'Sales Executive', class: 'bg-warning-subtle text-warning' }, 
    'App\\Models\\InternalConsumption': { label: 'Internal Consumption', class: 'bg-dark-subtle text-dark' },
  };
  return map[row.recipient_type] || { label: 'Unknown', class: 'bg-secondary-subtle text-secondary' };
},

    async openAddChallan() {
  await this.$refs.challanModal.openChallan();
  this.$openModal('challan_modal');
},

async openEditChallan(row) {
  await this.$refs.challanModal.openChallan(row);
  this.$openModal('challan_modal');
},

openViewChallan(id) {
  window.open(`/inventory/delivery-challans/view/${id}`, '_blank');
},
    
    async loadChallans(page = 1) {
     this.setLoading(true);
     try{
      const params = {
       page,
       search: this.search.trim() || '' ,
       status: this.activeStatus || ''
      };
      const query_string = new URLSearchParams(params).toString();
      const response = await axios.get(`/inventory/delivery-challans?${query_string}`);
      this.data = response.data.data.data;
      this.pagination = {
        current_page: response.data.data.current_page,
        per_page: response.data.data.per_page,
        last_page: response.data.data.last_page,
        total: response.data.data.total,
        links: response.data.data.links
      };
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
    },

    changePage(url){
     if (!url) return;
     const page = new URL(url).searchParams.get("page");
     this.loadChallans(page);
    },

    clearFilter(){
     this.search = '';
     this.activeStatus = '';
     this.loadChallans();
    },

statusBadge(status) {
  const map = {
    draft: 'bg-warning-subtle text-warning',
    dispatched: 'bg-success-subtle text-success',
    received: 'bg-info-subtle text-info',
    cancelled: 'bg-danger-subtle text-danger',
    partial_pending: 'bg-warning-subtle text-warning', 
    completed: 'bg-primary-subtle text-primary',
  };
  return map[status] || 'bg-secondary-subtle text-secondary';
},

    formatDate(dateStr) {
     if (!dateStr) return '-';
     const d = new Date(dateStr);
     return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
    },

    formatCurrency(val) {
     return parseFloat(val || 0).toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
    },

recipientName(row) {
  if (row.recipient_type === 'App\\Models\\Customer') {
    return row.recipient?.company_name || row.recipient?.name || '-';
  }
  if (row.recipient_type === 'App\\Models\\WorkOrder') {
    return row.recipient?.name || '-';
  }
  if (row.recipient_type === 'App\\Models\\SalesExecutive') {
    return row.recipient?.user?.name || '-';
  }
  if (row.recipient_type === 'App\\Models\\InternalConsumption') {
    return row.recipient?.user?.name || '-';
  }
  // Engineer
  return row.recipient?.user?.name || row.recipient_details?.name || '-';
},

    warehouseName(row) {
     return row.warehouse?.name || '-';
    },

    async dispatchChallan(row) {
  const dispatchableStatuses = ['draft', 'partial_pending', 'partial_dispatched'];
  if (!dispatchableStatuses.includes(row.status)) return;
     try {
      const result = await this.$swal({
       title: 'Dispatch Challan?',
       text: `Are you sure you want to dispatch ${row.challan_number}?`,
       icon: 'question',
       showCancelButton: true,
       confirmButtonText: 'Yes, Dispatch',
       cancelButtonText: 'Cancel',
       confirmButtonColor: '#e84040',
      });
      if (result.isConfirmed) {
       this.setLoading(true);
       const response = await axios.patch(`/inventory/delivery-challans/${row.id}/dispatch`);
       this.$swalToast(response.data.message);
       this.loadChallans(this.pagination.current_page);
       this.loadStats();
      }
     } catch (error) {
      this.$swalToast(error.message, 'error');
     } finally {
      this.setLoading(false);
     }
    },
    async deleteChallan(row) {
  try {
    const result = await this.$swal({
      title: 'Delete Challan?',
      text: `Are you sure you want to delete ${row.challan_number}? This action cannot be undone.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Delete',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#e84040',
    });
    if (result.isConfirmed) {
      this.setLoading(true);
      const response = await axios.delete(`/inventory/delivery-challans/${row.id}`);
      this.$swalToast(response.data.message);
      this.loadChallans(this.pagination.current_page);
      this.loadStats();
    }
  } catch (error) {
    this.$swalToast(error.message, 'error');
  } finally {
    this.setLoading(false);
  }
},

  },
};
</script>

<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>

<!-- Page Wrapper -->
<div class="page-wrapper">
  <div class="content">
    <!-- Breadcrumb -->
    <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
      <breadcrumb :title="title" :text="text" :text1="text1" />
      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap gap-2">
           <a v-if="auth.role?.name !== 'Internal consumption'" href="javascript:void(0);" class="btn btn-primary d-flex align-items-center" @click="openAddChallan()">
              <i class="ti ti-circle-plus me-2"></i>Add Delivery Challan
          </a>
        <a v-if="auth.type === 'ADMIN'" href="javascript:void(0);" class="btn btn-outline-danger d-flex align-items-center me-2 position-relative" @click="openPendingItems()">
          <i class="ti ti-clock me-2"></i>Exceed budget items
          <span v-if="pending_count > 0" class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style="font-size:10px;">
            {{ pending_count }}
          </span>
        </a>
      </div>
    </div>
    <!-- /Breadcrumb -->

  <!-- Stats Cards -->
  <div class="row g-3 mb-3" v-if="stats && stats.length && auth.role?.name !== 'Internal consumption'">
    <div class="col-6 col-md-4 col-lg-3 col-xl-3" v-for="stat in stats" :key="stat.status">
      <div class="card mb-0 border-0 shadow-sm" style="cursor:pointer;" :style="activeStatus === stat.status ? 'border: 1px solid #1a56db !important;' : ''" @click="filterByStatus(stat.status)">
        <div class="card-body p-3">
          <div class="d-flex align-items-center justify-content-between mb-2">
            <span class="badge rounded-pill" :class="stat.bg_color" style="font-size:10px;text-transform:capitalize;">
              {{ stat.status.replace('_', ' ') }}
            </span>
            <span class="fw-bold text-dark" style="font-size:20px;">{{ stat.count }}</span>
          </div>
          <div class="d-flex align-items-center justify-content-between">
            <span class="text-muted" style="font-size:11px;">{{ formatCurrency(stat.amount) }}</span>
            <span class="text-muted" style="font-size:11px;">{{ stat.percentage }}%</span>
          </div>
          <div class="progress mt-2" style="height:3px;">
            <div class="progress-bar" :class="stat.bg_color" :style="{width: stat.percentage + '%'}"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Stats Cards -->

    <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
    <h5>Delivery Challans</h5>
    
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
    
    <div class="me-3" v-if="search">
     <a href="javascript:void(0);" class="text-danger" @click="clearFilter()"><i class="ti ti-filter-x"></i></a>
    </div>  

    <div class="me-3">
    <div class="input-icon-end position-relative">
     <input type="text" class="form-control" v-model="search" placeholder="Search...."/>
    </div>
    </div>

    <div class="me-3">
     <button type="button" class="btn btn-dark" @click="loadChallans()"><i class="ti ti-search"></i></button>
    </div>

    </div>
    
   </div>

    <div class="card-body card-table-wrapper">
    <div class="custom-datatable-filter table-responsive">
    <table class="card-table" v-if="data.length">
     <thead>
        <tr>
        <th>#</th>
        <th>Challan No</th>
        <th>Recipient</th>
        <th>Type</th>
        <th>Warehouse</th>
        <th>Dispatch Date</th>
        <th>Total</th>
        <th>Status</th>
        <th>Actions</th>
        </tr>
     </thead>
     <tbody>
        <tr v-for="(row, index) in data" :key="row.id">
        <td>{{ serialNo + index + 1 }}.</td>  
        <td>
        <a class="text-primary" href="javascript:void(0);" @click="openViewChallan(row.id)">
        {{ row.challan_number }}
        </a>
        </td>
        <td>{{ recipientName(row) }}</td>
        <td>
        <span class="badge rounded-pill" :class="recipientType(row).class">
          {{ recipientType(row).label }}
        </span>
      </td>
        <td>
         <span class="badge bg-light text-primary border rounded-pill">{{ warehouseName(row) }}</span>
        </td>
        <td>{{ formatDate(row.dispatch_date) }}</td>
        <td>{{ formatCurrency(row.total) }}</td>
        <td>
         <span class="badge rounded-pill" :class="statusBadge(row.status)">
          {{ row.status.charAt(0).toUpperCase() + row.status.slice(1) }}
         </span>
        </td>
        <td>
        <div class="dropdown">
        <button class="btn btn-icon btn-sm rounded-circle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
        <i class="ti ti-dots-vertical"></i>
        </button>
        <ul class="dropdown-menu dropdown-menu-end p-3">
        <li>
          <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="openViewChallan(row.id)">
         <i class="ti ti-eye me-1"></i>View
        </a>
        </li>
        <li>
          <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="openActivityLog(row)">
            <i class="ti ti-activity me-1"></i>History
          </a>
        </li>

        <li v-if="row.status === 'dispatched' && row.recipient_type === 'App\\Models\\Engineer'">
          <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="openReturnDC(row)">
            <i class="ti ti-arrow-back-up me-1"></i>Return DC
          </a>
        </li>
        <!-- <li v-if="row.status === 'draft'">
<a class="dropdown-item rounded-1" href="javascript:void(0);" @click="openEditChallan(row)">
         <i class="ti ti-edit me-1"></i>Edit
        </a>
        </li> -->
        <li v-if="['draft', 'partial_pending', 'partial_dispatched'].includes(row.status)">
        <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="dispatchChallan(row)">
         <i class="ti ti-truck-delivery me-1"></i>Dispatch
        </a>
        </li>
        <li v-if="!['dispatched', 'partial_dispatched'].includes(row.status)">
          <a class="dropdown-item rounded-1 text-danger" href="javascript:void(0);" @click="deleteChallan(row)">
            <i class="ti ti-trash me-1"></i>Delete
          </a>
        </li>
        <li v-if="row.status === 'dispatched' && row.recipient_type === 'App\\Models\\InternalConsumption' && auth.internal_consumption">
          <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="openProduction(row)">
            <i class="ti ti-assembly me-1"></i>Create Production
          </a>
        </li>
        </ul>
        </div>  
        </td>
        </tr>
      </tbody>
     </table>

    <div v-else class="p-3 text-center text-muted"> No records found. </div>
    </div>

    <!-- Pagination -->
    <nav v-if="pagination.links.length > 3" class="m-3">
      <ul class="pagination pagination-sm">
        <li v-for="(link, index) in pagination.links" :key="index"
          :class="['page-item', { active: link.active, disabled: !link.url }]">
          <a class="page-link" href="javascript:void(0)" v-html="link.label" @click="changePage(link.url)"></a>
        </li>
      </ul>
    </nav>
  </div>
 </div>
</div>

<app-footer></app-footer>

</div>
<!-- /Page Wrapper -->

<!-- Challan Activity Modal -->
<!-- Challan Activity Modal -->
<div class="modal fade" id="challan_activity_modal" tabindex="-1">
  <div class="modal-dialog modal-dialog-scrollable modal-md">
    <div class="modal-content">
      <div class="modal-header border-0 pb-0">
        <div>
          <h5 class="modal-title fw-bold mb-1">Activity Log</h5>
          <span class="text-muted fs-12">{{ activity_challan_number }}</span>
        </div>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body" style="padding-top: 2px !important">

        <div v-if="activity_logs.length" class="position-relative ms-3">
          <!-- Timeline line -->
          <div class="position-absolute" style="left: 6px; top: 12px; bottom: 12px; width: 2px; background: #e9ecef;"></div>

          <div v-for="(log, index) in activity_logs" :key="log.id" class="d-flex align-items-start mb-3 position-relative">
            <!-- Timeline dot -->
            <div class="rounded-circle flex-shrink-0 me-3 position-relative" 
                 :style="{
                   width: '14px', height: '14px', 
                   background: index === 0 ? '#0d6efd' : '#adb5bd',
                   border: '2px solid #fff',
                   boxShadow: '0 0 0 2px ' + (index === 0 ? '#0d6efd' : '#dee2e6'),
                   zIndex: 1
                 }">
            </div>
            <!-- Content card -->
            <div class="card border shadow-none w-100 mb-0" :class="index === 0 ? 'border-primary border-opacity-25' : ''">
              <div class="card-body p-2 px-3">
                <p class="mb-1 fs-13" v-html="log.description"></p>
                <small class="text-muted">
                  <i class="ti ti-clock me-1"></i>{{ formatDateTime(log.created_at) }}
                </small>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="text-center text-muted py-5">
          <i class="ti ti-history fs-1 d-block mb-2 opacity-50"></i>
          <p class="mb-0">No activity found.</p>
        </div>

      </div>
      <div class="modal-footer border-0 pt-0">
        <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<delivery-challan-modal ref="challanModal" @updated="onUpdated"></delivery-challan-modal>
<pending-items-modal ref="pendingItemsModal" @updated="onUpdated"></pending-items-modal>
<production-modal ref="productionModal" @updated="onUpdated"></production-modal>

</template>

<style scoped>
.table-responsive {
  overflow-y: auto;
}
</style>